import { useNavigate } from "react-router-dom";

export const useCustomNavigate=() => {
   const navigate=useNavigate();
   const jumpTo=(path:string)=>{
    navigate(path);
 }
    return {jumpTo}
}